(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["keiray-collection-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.keiray-collection-navigation').forEach((navigation) => {
    const groups = navigation.querySelectorAll('.keiray-collection-navigation__group');

    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open) {
          groups.forEach((otherGroup) => {
            if (otherGroup !== group) otherGroup.open = false;
          });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["keiray-sticky-add"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('keiray-sticky-add'))customElements.define('keiray-sticky-add',class extends HTMLElement{connectedCallback(){this.native=document.getElementById('ProductSubmitButton-'+this.dataset.section);if(!this.native)return;this.button=this.querySelector('button');this.button.addEventListener('click',()=>this.native.click());this.observer=new IntersectionObserver(entries=>{this.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0;},{threshold:0});this.observer.observe(this.native);this.mutation=new MutationObserver(()=>this.sync());this.mutation.observe(this.native,{attributes:true,childList:true,subtree:true});this.sync();}sync(){this.button.disabled=this.native.disabled;this.button.textContent=this.native.querySelector('span')?.textContent.trim()||this.native.textContent.trim();}disconnectedCallback(){this.observer?.disconnect();this.mutation?.disconnect();}});
  } catch(e) { console.error(e); }
})();

})();
